import { useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { FOVEACanvas } from './FOVEACanvas';
import { ModelStatus } from 'pages/ModelStatus';
import { useModelLoader } from 'hooks';
import {
  clearUpdateData,
  clearSerializedData,
  setGuidURL,
  setReinitializeCanvas,
  setExportModel,
  setExportedModelData,
} from 'store/actions/canvasActions';
import { CanvasContainer } from './styles';
import { ActionArea } from './ActionArea';
import constants from 'constants';

const { VIEWER_MODEL_FORMAT } = constants;

const FOVEA = () => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();

  const guid = pathname.split('fovea/')[1];
  const loader = useModelLoader({ guid, format: VIEWER_MODEL_FORMAT });

  const cleanup = useCallback(() => {
    dispatch(clearUpdateData());
    dispatch(clearSerializedData());
    dispatch(setGuidURL(null));
    dispatch(setReinitializeCanvas(false));
    dispatch(setExportModel(false));
    dispatch(setExportedModelData(null));
  }, [ dispatch ]);

  useEffect(() => {
    return () => cleanup();
  }, [ cleanup ]);

  if (loader.showStatus) {
    return (
      <CanvasContainer>
        <ModelStatus {...loader.statusProps} />
      </CanvasContainer>
    );
  }

  return (
    <CanvasContainer>
      <FOVEACanvas previewURL={loader.previewURL} />
      <ActionArea guidURL={loader.previewURL} />
    </CanvasContainer>
  );
};

export { FOVEA };
